import PropTypes from 'prop-types';
import React from 'react';

import {Link} from 'react-router-dom';

import {ROUTES} from '../config';
import Events from '../containers/events';

const ListItem = ({feature}) => (
	<Link
		className="bsknacht17-list__item"
		key={feature.id}
		to={ROUTES.DETAILS.path.replace(':featureId', feature.id)}
	>
		<h2 className="bsknacht17-list__item__headline">
			{feature.properties.name}
		</h2>
		<Events events={feature.properties.events} isExpanded={false} />
	</Link>
);

ListItem.propTypes = {
	feature: PropTypes.object.isRequired,
};

export default ListItem;
